<script>
import styleHOCFactory from './utils';
export default styleHOCFactory();
</script>

<style module>
@import 'styles/variables.css';

._ctastyle {
  composes: white from global;
  &:hover, &:global(.-hover) {
    color: var(--green);
    fill: var(--green);
  }
  &:disabled, &:global(.-disabled) {
    color: rgba(255,255,255, .5);
    fill: rgba(255,255,255, .5);
    pointer-events: none;
  }
}
</style>
